import { UserPermissions } from '@backrs_ui/common-ui';

import { getBackrsToken } from '@backrs_ui/grow-ui/src/utils/tokenHelpers';

import { createApi } from '@reduxjs/toolkit/query/react';

import { userPermissionsTransformer, UIPermissionList } from './user.transformer';
import { baseQueryWithAuth } from '../baseQuery';

const ENVIRONMENT_URL = process.env.REACT_APP_API_BASEURL;

export const userApi = createApi({
  reducerPath: 'userApi',
  baseQuery: async () => ({ data: {} }),
  endpoints: (builder) => ({
    fetchUserPermissions: builder.query<UIPermissionList | null, undefined>({
      async queryFn(_, api) {
        if (!ENVIRONMENT_URL) {
          return {
            error: {
              status: 'CUSTOM_ERROR',
              error: 'No environment URL found',
            },
          };
        }

        const backrsToken = getBackrsToken();

        if (!backrsToken) {
          return {
            error: { status: 'CUSTOM_ERROR', error: 'No backrs token found' },
          };
        }

        const result = await baseQueryWithAuth(
          {
            url: `/users/current-user/permissions`,
            method: 'GET',
          },
          api,
          {},
        );

        if (result.error) {
          return { error: result.error };
        }

        const growPermissions = userPermissionsTransformer(result.data as UserPermissions);

        return { data: growPermissions };
      },
    }),
  }),
});

export const { useFetchUserPermissionsQuery } = userApi;
